export const colorObj = {
  colPointBlue: '#007AFE',
  colPointOrange: '#FF4C14',
  colPointMin: '#3695AE',
  colWhite: '#ffffff',
  colBlack: '#191919',
  colGray1: '#f8f8f8',
  colGray2: '#f4f4f4',
  colGray3: '#eaeaea',
  colGray4: '#cccccc',
  colGray5: '#aaaaaa',
  colGray6: '#898989',
  colGray7: '#666666',
};

export const fontWeight = {
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
};
